// frontend/src/pages/supplierCatalogItemLabel.js
//
// How the Supplier catalog NAMES a relation's item in a sentence — the delete
// confirmation, the "removed"/"default updated" toasts.
//
// It exists because the relation's wire shape nests the item under its own
// keys: SupplierCatalogItemSerializer.get_item sends
// `{id, code, name, image_url, sku}` (backend/api/serializers.py), while
// `formatItemLabel` reads the flat `item_code` / `item_name` / `sku` every
// other screen carries. One home for that mapping, so no call site passes
// `row.item.code` straight into a sentence — on a Shopify store that is the
// variant GID's numeric suffix, a number the merchant has never seen.
//
// The grid's own Product cell reaches the same fields by dot-path
// (`codeField: 'item.code'`); this is the prose half of the same contract.

import { formatItemLabel } from '../utils/itemLabel';

/**
 * @param {{item?: {code?: string, name?: string, sku?: string}}} row
 *   A SupplierCatalogItem row as the list endpoint sends it.
 * @param {boolean} isShopify  Store capability, from `useIsShopify()`.
 * @returns {string} "Wool scarf (SCARF-01)" on a Shopify store,
 *   "SCARF-01 — Wool scarf" elsewhere, '' for a row carrying no item.
 */
export const supplierCatalogItemLabel = (row, isShopify) => formatItemLabel({
  item_code: row?.item?.code,
  item_name: row?.item?.name,
  sku: row?.item?.sku,
}, isShopify);
